export default [ {
  path: '/pengchengxinli',
  name: 'pengchengxinli',
  redirect: {
    name: 'pengchengxinliBaseInfo'
  },
  meta: {
    title: '朋橙心理',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/pengchengxinli/index'], resolve)
  },
  children: [{
    path: 'baseinfo',
    name: 'pengchengxinliBaseInfo',
    meta: {
      title: '朋橙心理',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pengchengxinli/baseInfo'], resolve)
    }
  }, {
    path: 'zhuanjia/:id',
    name: 'pengchengxinliZhuanjia',
    meta: {
      title: '专家问诊',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pengchengxinli/zixun'], resolve)
    }
  }, {
    path: 'general',
    name: 'pengchengxinliGeneral',
    meta: {
      title: '看咨询',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pengchengxinli/general'], resolve)
    }
  }, {
    path: 'report',
    name: 'pengchengxinliReport',
    meta: {
      title: '体检报告解读',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pengchengxinli/general'], resolve)
    }
  }, {
    path: 'consult',
    name: 'pengchengxinliConsult',
    meta: {
      title: '我的咨询',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pengchengxinli/consult'], resolve)
    }
  }, {
    path: 'questionnaire',
    name: 'pengchengxinliQuestionnaire',
    meta: {
      title: '健康状况自我诊断表',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pengchengxinli/questionnaire'], resolve)
    }
  }]

}]
